// extracted by mini-css-extract-plugin
export var planCard = "_vj-0";
export var planList = "_vj-1";